import { Listing, ListingSchema, type ListingData } from "@lumora/core";

/** Custom fields every app listing carries (schema-driven, same Listing model as dealership stock). */
export const APP_SCHEMA = new ListingSchema([
  { key: "platform", label: "Platform", onCard: true },
  { key: "cover", label: "Cover image" },
  { key: "appStoreUrl", label: "App Store URL" },
  { key: "playStoreUrl", label: "Google Play URL" },
]);

/**
 * Apps live in the `lumora` site's content `portfolioItems` (one row per app, `fields.kind === "app"`).
 * Populate with DevOps/partner/apps (upload-app-images.mjs, then apps-populate.console.js).
 */
export const APP_KIND = "app";

/** Minimal shape of the site-content rows we read (structural, so tests need no network types). */
export interface AppContentLike {
  portfolioItems?: readonly ListingData[] | null;
}

/** Public site content -> app listings: kind=app rows only, archived dropped. */
export function appListingsFromContent(content: AppContentLike | null | undefined): Listing[] {
  const rows = content?.portfolioItems ?? [];
  const out: Listing[] = [];
  rows.forEach((row, i) => {
    if (row?.fields?.kind !== APP_KIND) return;
    const l = Listing.fromData(row, `app-${i}`);
    if (!l.archived) out.push(l);
  });
  return out;
}

/** Card / hero-window image: the cover field, else the first screenshot. */
export function appCover(l: Listing): string {
  return l.fields.cover || l.coverImage || "";
}
